/* Jeans Pins urgency UI. The viewer counter is a merchant-requested simulation.
   Low-stock flags are explicit variant metafields, not inventory calculations. */
(() => {
  if (window.__bjPinsUrgency) return;
  window.__bjPinsUrgency = true;

  if (!customElements.get('bj-pins-low-stock')) {
    customElements.define('bj-pins-low-stock', class extends HTMLElement {
      connectedCallback() {
        try { this.variants = JSON.parse(this.dataset.variants || '[]'); }
        catch (_) { this.hidden = true; return; }
        this.picker = this.closest('variant-selects');
        if (!this.picker) { this.hidden = true; return; }
        this.onChange = () => this.update();
        this.picker.addEventListener('change', this.onChange);
        this.update();
      }
      disconnectedCallback() {
        this.picker?.removeEventListener('change', this.onChange);
      }
      update() {
        const options = Array.from(this.picker.querySelectorAll('fieldset, select'))
          .map(el => el.tagName === 'SELECT' ? el.value : el.querySelector('input:checked')?.value);
        const variant = this.variants.find(v => v.options.length === options.length &&
          v.options.every((value, i) => value === options[i]));
        this.hidden = !(variant && variant.available && variant.low);
      }
    });
  }

  const active = new Map();
  function nextCount(current, random = Math.random) {
    let direction = random() < 0.5 ? -1 : 1;
    if (current <= 10) direction = 1;
    if (current >= 30) direction = -1;
    const room = direction > 0 ? 30 - current : current - 10;
    return current + direction * (1 + Math.floor(random() * Math.min(5, room)));
  }
  function mount(badge) {
    const gallery = badge.closest('media-gallery');
    const viewer = gallery?.querySelector('slider-component[id^="GalleryViewer-"]');
    const list = viewer?.querySelector('.product__media-list');
    if (!gallery || !viewer || !list || active.has(gallery)) return;
    const countNode = badge.querySelector('[data-bj-pins-count]');
    const key = 'bj-pins-watching:' + badge.dataset.productId;
    let count;
    try { count = Number(sessionStorage.getItem(key)); } catch (_) {}
    if (!Number.isInteger(count) || count < 10 || count > 30) count = 10 + Math.floor(Math.random() * 21);
    function paint() {
      countNode.textContent = String(count);
      try { sessionStorage.setItem(key, String(count)); } catch (_) {}
    }
    const desktop = matchMedia('(min-width: 750px)');
    let host;
    let frame;
    function position() {
      frame = null;
      const firstVisible = Array.from(list.querySelectorAll('li.product__media-item'))
        .find(li => !li.hidden && getComputedStyle(li).display !== 'none');
      const target = desktop.matches && list.classList.contains('grid-gallery') ? firstVisible : viewer;
      if (!target) { badge.hidden = true; return; }
      if (host !== target) {
        host?.classList.remove('bj-pins-watching-host');
        host = target;
        host.classList.add('bj-pins-watching-host');
      }
      if (badge.parentElement !== target) target.appendChild(badge);
      badge.hidden = false;
      // Keep the badge clear of the store's existing floating discount tab.
      badge.style.left = '';
      badge.style.maxWidth = '';
      const tab = document.querySelector('.bj-scratch-tab');
      if (tab) {
        const obstacle = tab.getBoundingClientRect();
        const rect = badge.getBoundingClientRect();
        if (obstacle.width && obstacle.height && rect.top < obstacle.bottom &&
            rect.bottom > obstacle.top && rect.left < obstacle.right && rect.right > obstacle.left) {
          const inset = Math.max(10, obstacle.right - host.getBoundingClientRect().left + 8);
          badge.style.left = inset + 'px';
          badge.style.maxWidth = 'calc(100% - ' + (inset + 10) + 'px)';
        }
      }
    }
    function schedule() { if (frame == null) frame = requestAnimationFrame(position); }
    const observer = new MutationObserver(records => {
      if (records.some(r => !badge.contains(r.target))) schedule();
    });
    observer.observe(list, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    desktop.addEventListener('change', schedule);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    const timer = setInterval(() => {
      if (!gallery.isConnected) { cleanup(); return; }
      if (document.hidden) return;
      count = nextCount(count);
      paint();
    }, 5000);
    function cleanup() {
      clearInterval(timer);
      observer.disconnect();
      desktop.removeEventListener('change', schedule);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      if (frame != null) cancelAnimationFrame(frame);
      host?.classList.remove('bj-pins-watching-host');
      active.delete(gallery);
    }
    active.set(gallery, cleanup);
    paint();
    position();
  }
  function init() {
    for (const [gallery, cleanup] of active) if (!gallery.isConnected) cleanup();
    document.querySelectorAll('[data-bj-pins-watching]').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    for (const [gallery, cleanup] of active) if (event.target.contains(gallery)) cleanup();
  });
})();
